import { render, staticRenderFns } from "./mails-send.vue?vue&type=template&id=d3d2a168&"
import script from "./mails-send.vue?vue&type=script&lang=js&"
export * from "./mails-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports